/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataCommissionInviteStatsPageItemVo } from './PageDataCommissionInviteStatsPageItemVo';
import {
    PageDataCommissionInviteStatsPageItemVoFromJSON,
    PageDataCommissionInviteStatsPageItemVoFromJSONTyped,
    PageDataCommissionInviteStatsPageItemVoToJSON,
    PageDataCommissionInviteStatsPageItemVoToJSONTyped,
} from './PageDataCommissionInviteStatsPageItemVo';

/**
 * 
 * @export
 * @interface ResponsePageDataCommissionInviteStatsPageItemVo
 */
export interface ResponsePageDataCommissionInviteStatsPageItemVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataCommissionInviteStatsPageItemVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataCommissionInviteStatsPageItemVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataCommissionInviteStatsPageItemVo}
     * @memberof ResponsePageDataCommissionInviteStatsPageItemVo
     */
    data?: PageDataCommissionInviteStatsPageItemVo;
}

/**
 * Check if a given object implements the ResponsePageDataCommissionInviteStatsPageItemVo interface.
 */
export function instanceOfResponsePageDataCommissionInviteStatsPageItemVo(value: object): value is ResponsePageDataCommissionInviteStatsPageItemVo {
    return true;
}

export function ResponsePageDataCommissionInviteStatsPageItemVoFromJSON(json: any): ResponsePageDataCommissionInviteStatsPageItemVo {
    return ResponsePageDataCommissionInviteStatsPageItemVoFromJSONTyped(json, false);
}

export function ResponsePageDataCommissionInviteStatsPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataCommissionInviteStatsPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataCommissionInviteStatsPageItemVoFromJSON(json['data']),
    };
}

export function ResponsePageDataCommissionInviteStatsPageItemVoToJSON(json: any): ResponsePageDataCommissionInviteStatsPageItemVo {
    return ResponsePageDataCommissionInviteStatsPageItemVoToJSONTyped(json, false);
}

export function ResponsePageDataCommissionInviteStatsPageItemVoToJSONTyped(value?: ResponsePageDataCommissionInviteStatsPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataCommissionInviteStatsPageItemVoToJSON(value['data']),
    };
}

